<template>
  <b-row>
    <div class="col-md-12">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">
          <b-form-checkbox
            id="checkbox-1"
            v-model="isNewCustomer"
            name="checkbox-1"
            :value="1"
            :unchecked-value="0"
          >
            Penjualan customer baru
          </b-form-checkbox>
          <fg-input label="Customer" v-if="!isNewCustomer">
            <div class="form-group input-typeahead" v-bind:class="customerError !== null ? 'has-error':''">
              <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :labelFields="['name']" placeholder="Cari Customer" :urlSearch="apiUrl.customer" arr-response="data" :model="model.customer" />
              <input type="hidden" :model="checkCustomer"/>
              <p v-if="customerError !== null" class="error" v-html="customerError"></p>
            </div>
          </fg-input>
          <b-row v-else>
            <b-col>
              <fg-input :required="false" for-input="name" type="text" name="name" id="name" label="Nama" placeholder="Masukkan nama" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="Name"/>
              <fg-input type="text" name="address" id="address" label="Alamat" placeholder="Enter address" v-model="model.address"/>
              <fg-input  type="text" name="email" id="email" label="Email" placeholder="Masukkan email" v-model="model.email"/>
              <fg-input type="text" name="phone" id="phone" label="Telelpon" placeholder="Masukkan nomor telepon" v-model="model.phone"/>
            </b-col>
          </b-row>
          <b-row class="border ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in lines" v-bind:key="index" >
            <template v-if="isNewCustomer || model.customer.value !== null">
              <b-col md="12">
                <fg-input label="Produk" v-if="$route.params.id === undefined">
                  <div class="form-group input-typeahead" v-bind:class="productError !== null ? 'has-error':''">
                    <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :disabled="true" :labelFields="['product_name']" placeholder="Cari Product" :urlSearch="apiUrl.productSearch" arr-response="data" :model="line.product" :formType="'productSearch'" />
                    <p v-if="productError !== null" class="error" v-html="productError"></p>
                  </div>
                </fg-input><fg-input label="Product" v-else>
                  <p>{{line.product.name}} - {{line.product.category}} - {{line.product.color}} - {{line.product.size}}</p>
                </fg-input>
              </b-col>
              <!-- <b-col md="3 pl-3">
                <fg-input label="Harga Jual">
                  <p class="pt-2"><strong>{{formatNumber(line.product.sellingPrice * line.quantity)}}</strong></p>
                </fg-input>
              </b-col> -->
              <b-col md="3 pl-3">
                <fg-input v-if="model.customer.category === 'Sepesial Member' && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.smPrice) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="model.customer.category === 'Member' && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.memberPrice) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="model.customer.category === 'Dropshipper' && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.dropshipper) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="model.customer.category === 'Gold Member' && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.gold_member) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="(totalQty > 2 && totalQty <= 11) && (lines.length > 2 && lines.length <= 11) || (line.quantity > 2 && line.quantity <= 11) && (model.customer.category !== 'Member' || model.customer.category !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more3) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="totalQty >= 11 && lines.length > 11 || line.quantity > 11 && (model.customer.category !== 'Member' || model.customer.category !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more12) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="(totalQty > 2 && totalQty <= 11) && (model.customer.category !== 'Member' || model.customer.category !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more3) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="totalQty >= 11 && (model.customer.category !== 'Member' || model.customer.category !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more12) * line.quantity) : 0}}</strong></p>
                </fg-input>
                <fg-input v-else-if="Object.keys(line.product).length > 0" label="Harga Jual">
                  <p class="pt-2"><strong>{{formatNumber(line.product.sellingPrice * line.quantity)}}</strong></p>
                </fg-input>
              </b-col>
              <b-col md="2">
                <fg-input label="Kuantitas" type="number" :disabled="$route.params.id !== undefined" v-model="line.quantity"/>
              </b-col>
              <b-col md="1 mt-4-5 text-center">
                <b-button type="button" @click="removeLine(index)" v-if="index >= 1 && $route.params.id === undefined" class="btn btn-danger"><i class="fa fa-times"></i></b-button>
              </b-col>
              <b-col md="1 mt-4-5 ml-2 text-center">
                <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
              </b-col>
            </template>
          </b-row>
          <b-row>
            <b-col cols="6">
              <fg-input label="Diskon" type="number" v-model="model.diskon"/>
            </b-col>
            <b-col cols="6">
              <fg-input label="PPN (%)" type="number" v-model="model.ppn"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <fg-input label="Mau disablon?">
                <b-form-group>
                  <b-form-radio-group
                    id="isSablon"
                    v-model="model.isSablon"
                    :options="optionsSablon"
                    name="radio-sablon"
                  ></b-form-radio-group>
                </b-form-group>
              </fg-input>
            </b-col>
          </b-row>
          <b-row v-if="model.isSablon === 1">
            <b-col cols="4">
              <fg-input label="Sablon">
                <div class="form-group input-typeahead" v-bind:class="sablonError !== null ? 'has-error':''">
                  <typeahead ref="userProfileUuidTypeahead" customQueryParamName="title" :labelFields="['title']" placeholder="Cari Sablon" :urlSearch="apiUrl.sablon" arr-response="data" :model="model.sablon" />
                  <p v-if="sablonError !== null" class="error" v-html="sablonError"></p>
                </div>
              </fg-input>
            </b-col>
            <b-col cols="4">
              <fg-input label="Harga Jual Sablon">
                <p class="pt-2"><strong>{{formatNumber(model.sablon.sellingPrice * model.sablonQuantity)}}</strong></p>
              </fg-input>
            </b-col>
            <b-col cols="4">
              <fg-input label="Kuantitas" type="number" min="1" v-model="model.sablonQuantity"/>
            </b-col>
          </b-row>
          <template v-if="model.customer.category !== null && model.customer.category === 'Pelanggan' && model.customer.count_point >= 5000 && totalSummary >= 50000">
          <b-row>
            <b-col cols="12">
              <fg-input label="Gunakan Point?">
                <b-form-group>
                  <b-form-radio-group
                    id="isUsePoint"
                    v-model="model.is_use_point"
                    :options="optionsPoint"
                    name="radio-sablon"
                  ></b-form-radio-group>
                </b-form-group>
              </fg-input>
            </b-col>
          </b-row>
          <b-row v-if="model.is_use_point === true">
            <b-col cols="4">
              <fg-input label="Total point saat ini">
                <p class="pt-2"><strong>{{formatPoint(model.customer.count_point)}}</strong></p>
              </fg-input>
            </b-col>
            <b-col cols="4">
              <fg-input label="Total Penggunaan Point" type="number" min="1" :max="model.customer.count_point" v-model="model.how_use"/>
            </b-col>
          </b-row>
          </template>
          <b-row>
            <b-col cols="12">
              <fg-input label="Cara Pembayaran">
                <b-form-group>
                  <b-form-radio-group
                    id="method-payement"
                    v-model="model.paymentType"
                    :options="optionsPaymentType"
                    name="radio-method-payement"
                  ></b-form-radio-group>
                </b-form-group>
              </fg-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <fg-input label="Shipping Payment">
                <b-form-group>
                  <b-form-input
                    type="number"
                    id="shipping-payement"
                    v-model="model.shipping"
                    name="shipping-payement"
                  ></b-form-input>
                </b-form-group>
              </fg-input>
            </b-col>
          </b-row>
          <b-row v-if="model.paymentType === 2">
            <b-col cols="6">
              <fg-input label="Jumlah DP" type="number" v-model="model.downPayment"/>
            </b-col>
            <b-col cols="6">
              <fg-input label="sisa pembayaran">
                <p class="pt-2">
                  <strong>{{formatNumber(totalSummary - model.downPayment)}}</strong>
                </p>
              </fg-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <cancel-button/>
            </b-col>
            <b-col cols="6" class="text-right">
              <b-button class="mr-3" @click="doSubmit(4)"><font-awesome-icon icon="sticky-note"/> Simpan sebagai draft</b-button>
              <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
            </b-col>
          </b-row>
        </form>
      </card>
    </div>
    <div class="bubble-info">
      <div class="btn btn-warning" v-if="model.customer.category !== null &&  model.customer.category === 'Pelanggan'"><strong>Total Point: {{formatPoint(model.customer.count_point)}}</strong></div>
      <div class="btn btn-info"><strong>Total : {{formatNumber(totalSummary)}}</strong></div>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import Typeahead from '@/components/Typeahead'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch,
      Treeselect,
      Typeahead
    },
    data () {
      return {
        downPaymentDisabled: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          customer: window.AppConfig.apiUrl + 'customer',
          order: window.AppConfig.apiUrl + 'order',
          sablon: window.AppConfig.apiUrl + 'sablon',
          productSearch: window.AppConfig.apiUrl + 'product-search'
        },
        optionsPaymentType: [
          { text: 'Cash', value: 0 },
          { text: 'Tahan pembayaran', value: 1 },
          { text: 'Bayar di muka', value: 2 }
        ],
        optionsSablon: [
          { text: 'Ya', value: 1 },
          { text: 'Tidak', value: 0 }
        ],
        optionsPoint: [
          { text: 'Ya', value: true },
          { text: 'Tidak', value: false }
        ],
        isNewCustomer: 0,
        lines: [],
        blockRemoval: true,
        productList: [],
        productionCost: 0,
        customerList: [],
        customerError: null,
        productError: null,
        sablonError: null,
        total: 0,
        ppn: 0,
        totalQty: null,
        model: {
          name: null,
          how_use: 0,
          address: null,
          email: null,
          phone: null,
          customer: {
            value: null,
            category: null,
            count_point: null
          },
          sablon: {
            value: null,
            category: null,
            sellingPrice: null,
            capitalPrice: null
          },
          downPayment: 0,
          ppn: 0,
          diskon: 0,
          paymentType: 0,
          isSablon: 0,
          is_use_point: false,
          sablonCapitalPrice: 0,
          sablonSellingPrice: 0,
          sablonQuantity: 1,
          sablonTotal: 0,
          shipping: 0,
          remainingPayment: 0,
          total: 0
        },
        modelValidations: {
          name: {
            required: false
          },
          email: {
            required: false
          },
          phone: {
            required: false
          },
          address: {
            required: false
          },
          city: {
            required: false
          }
        }
      }
    },
    mounted () {
      this.initData()
      // this.addLine()
      this.resetValue()
    },
    computed: {
      checkCustomer: function () {
        if (this.model.customer.value === null) {
          if (!this.isNewCustomer) {
            this.lines = [{
              product: {
                value: null,
                sellingPrice: 0,
                capitalPrice: 0
              },
              quantity: 1
            }]
          }
        }
      },
      totalSummary: function () {
        this.model.total = 0
        this.model.subTotal = 0
        this.totalQty = 0
        this.lines.forEach(data => {
          this.totalQty += parseInt(data.quantity)
        })
        this.lines.forEach(data => {
          if (this.model.customer.id === 361 || this.model.customer.id === 360) {
            this.model.subTotal = data.product.sellingPrice * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.model.customer.category === 'Member' && data.product.sellingPrice > 0) {
            this.model.subTotal = data.product.memberPrice * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.model.customer.category === 'Sepesial Member' && data.product.sellingPrice > 0) {
            this.model.subTotal = data.product.smPrice * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.model.customer.category === 'Dropshipper' && data.product.sellingPrice > 0) {
            this.model.subTotal = data.product.dropshipper * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.model.customer.category === 'Gold Member' && data.product.sellingPrice > 0) {
            this.model.subTotal = data.product.gold_member * data.quantity
            this.model.total += this.model.subTotal
          } else if ((this.totalQty > 2 && this.totalQty <= 11) && (this.lines.length > 2 && this.lines.length <= 11) || (data.quantity > 2 && data.quantity <= 11) && (this.model.customer.category !== 'Member' && this.model.customer.category !== 'Sepesial Member')) {
            this.model.subTotal = data.product.more3 * data.quantity
            this.model.total += this.model.subTotal
          } else if ((this.totalQty > 2 && this.totalQty <= 11) && (this.model.customer.category !== 'Member' && this.model.customer.category !== 'Sepesial Member')) {
            this.model.subTotal = data.product.more3 * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.totalQty > 11 && this.lines.length > 11 || data.quantity > 11 && (this.model.customer.category !== 'Member' && this.model.customer.category !== 'Sepesial Member')) {
            this.model.subTotal = data.product.more12 * data.quantity
            this.model.total += this.model.subTotal
          } else if (this.totalQty > 11 && (this.model.customer.category !== 'Member' && this.model.customer.category !== 'Sepesial Member')) {
            this.model.subTotal = data.product.more12 * data.quantity
            this.model.total += this.model.subTotal
          } else {
            this.model.subTotal = data.product.sellingPrice * data.quantity
            this.model.total += this.model.subTotal
          }
        })
        if (this.model.isSablon === 1) {
          this.model.total = this.model.total + (this.model.sablon.sellingPrice * this.model.sablonQuantity)
        }
        if (this.model.is_use_point === 1) {
          this.model.total = this.model.total - this.model.how_use
        }
        if (this.model.diskon > 0) {
          this.model.total = this.model.total - this.model.diskon
        }
        if (this.model.ppn > 0) {
          let afterPpn = (this.model.total * this.model.ppn) / 100
          this.model.total = this.model.total + afterPpn
        }
        return this.model.total + parseInt(this.model.shipping)
      }
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      isNewCustomer () {
        this.resetValue()
      }
    },
    methods: {
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
      },
      addLine () {
        // let checkEmptyLines = this.lines.filter(line => line.color === null)
        // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        if (this.$route.params.id === undefined) {
          this.lines.push({
            product: {
              value: null,
              sellingPrice: 0,
              capitalPrice: 0,
              smPrice: 0,
              memberPrice: 0,
              dropshipper: 0,
              gold_member: 0,
              more3: 0,
              more12: 0
            },
            quantity: 1
          })
        }
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      resetValue () {
        this.model.customer.value = null
        this.model.customer.category = null
        this.model.customer.count_point = null
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.customer + '/' + this.$route.params.id)
        .then(response => {
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.model.phone = response.data.phone
          this.model.address = response.data.address
          this.model.village = response.data.village
          this.model.districts = response.data.districts
          this.model.city = response.data.city
          this.model.postalCode = response.data.postalCode
          this.model.personInCharge = response.data.personInCharge
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      doSubmit (status = null) {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$validator.validateAll().then(res => {
              if (res) {
                this.saveButtonData.isLoading = true
                let model = {
                  isNewCustomer: this.isNewCustomer
                }
                if (model.isNewCustomer === 0) {
                  model.customer = this.model.customer.value
                } else {
                  model.name = this.model.name
                  model.address = this.model.address
                  model.email = this.model.email
                  model.phone = this.model.phone
                }
                model.product = []
                this.lines.forEach(data => {
                  model.product.push({
                    productName: data.product.label,
                    productSize: data.product.value,
                    capitalPrice: data.product.capitalPrice,
                    sellingPrice: data.product.sellingPrice,
                    memberPrice: data.product.memberPrice,
                    smPrice: data.product.smPrice,
                    more3: data.product.more3,
                    more12: data.product.more12,
                    dropshipper: data.product.dropshipper,
                    gold_member: data.product.gold_member,
                    quantity: data.quantity
                  })
                })
                if (status !== null) {
                  model.status = status
                }
                model.diskon = this.model.diskon
                model.ppn = this.model.ppn
                model.isSablon = this.model.isSablon
                if (this.model.isSablon === 1) {
                  model.sablonId = this.model.sablon.value
                  model.sablonCapitalPrice = this.model.sablon.capitalPrice
                  model.sablonSellingPrice = this.model.sablon.sellingPrice
                  model.sablonQuantity = this.model.sablonQuantity
                }
                model.methodType = this.model.paymentType
                model.shipping = this.model.shipping
                model.downPayment = this.model.downPayment
                model.is_use_point = this.model.is_use_point
                model.how_use = this.model.how_use
                this.$http.post(this.apiUrl.order, model).then(response => {
                  this.saveButtonData.isLoading = false
                  this.$store.dispatch('notification/success', 'User has been added.')
                  window.location.href = document.URL.replace('/create', '/' + response.data.id)
                }).catch(error => {
                  this.saveButtonData.isLoading = false
                  this.$store.dispatch('notification/error', error)
                })
              }
            })
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      },
      formatPoint (num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: absolute;
    float: right !important;
    right: 0;
    width: 95%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .mt-4-5 {
    margin-top: 2rem !important;
  }
  .bubble-info {
    position: fixed;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Orders/Form.vue